import AuthService from "../auth/AuthService";
import hbscan from "../../api/hbscan";

class EslService {
    GetIsValidMac = async (macAddress: string): Promise<boolean> => {
        const URI = `/api/hbscan/esl/GetIsMacValid`;

        return (
            await hbscan.get<boolean>(URI, {
                headers: { Authorization: AuthService.guid },
                params: { macAddress }
            })
        ).data;
    };

    GetDoesMacAddressExist = async (macAddress: string): Promise<boolean> => {
        const URI = `/api/hbscan/esl/GetDoesMacAddressExist`;

        return (
            await hbscan.get<boolean>(URI, {
                headers: { Authorization: AuthService.guid },
                params: { macAddress }
            })
        ).data;
    };

}

const eslService = new EslService();

export default eslService;